// extracted by mini-css-extract-plugin
export default {"root":"SsY_2i","line":"UGHfip"};